
/**
 * @typedef {import('../../../api-v2/js-doc').V2UpdateBrokerFactoringConfigRequest} V2UpdateBrokerFactoringConfigRequest
 * @typedef {import('../../../api-v2/js-doc').V1UpdateDebtorRequest} V1UpdateDebtorRequest
 */
export class DebtorMapper {

  /**
   * @param {V1UpdateDebtorRequest} v1Request - V1 create invoice request body
   * @returns {V2UpdateBrokerFactoringConfigRequest} - V2 create invoice request body
   */
  static v1UpdateBrokerRequestToV2 (v1Request) {
    return {
      __ingestThrough: true,
      __v1Payload: {},
      limitAmount: v1Request.debtor_limit,
      limitNote: v1Request.changelog_notes,
      preferences: v1Request.payment_status_preferences,
      verificationDelay: v1Request.verification_delay,
      legalName: v1Request.name,
      doingBusinessAs: Array.isArray(v1Request.doing_business_as)
        ? v1Request.doing_business_as[0]
        : v1Request.doing_business_as,
      phone: v1Request.phone,
      bobtailStatus: v1Request.status,
      address: v1Request.address,
      address2: v1Request.address_2,
      city: v1Request.city,
      state: v1Request.state,
      zip: v1Request.zip,
      country: v1Request.country,
      mc: v1Request.mc,
      dot: v1Request.dot,
      authorityDate: v1Request.authority_date,
      authorityStatus: v1Request.authority_status
        ? v1Request.authority_status.charAt(0).toUpperCase() + v1Request.authority_status.slice(1)
        : undefined,
    }
  }

  /**
   * Maps v1 delivery options fields to v2 UpdateBrokerRequest format.
   * @param {V1UpdateDebtorRequest} v1Request
   * @returns {object}
   */
  static v1DeliveryOptionsToV2 (v1Request) {
    return {
      __ingestThrough: true,
      __v1Payload: {},
      requireCopies: v1Request.require_copies,
      requireEmail: v1Request.require_email,
      requireFax: v1Request.require_fax,
      requireOriginals: v1Request.require_originals,
      requireOnlineSubmit: v1Request.require_online_submit,
      fax: v1Request.fax,
      portalUrl: v1Request.online_submit_url,
      noaEmails: v1Request.noa_emails,
      invoiceDeliveryEmails: v1Request.invoice_delivery_emails,
      payStatusEmails: v1Request.pay_status_emails,
      mailingAddress: v1Request.mailing_address,
      mailingAddress2: v1Request.mailing_address_2,
      mailingCity: v1Request.mailing_city,
      mailingState: v1Request.mailing_state,
      mailingZip: v1Request.mailing_zip,
      mailingCountry: v1Request.mailing_country,
    }
  }
}

